import axios from 'axios';
import { handleAdminDashboardHttp401 } from '../lib/adminSession';
import { getAdminConsoleToken } from '../lib/adminConsoleToken';
import { isOidcAdminAuth } from '../lib/oidc/oidcConfig';
import { attachOidcBearer, handleOidcAxiosError } from '../lib/oidc/oidcAxios';

/**
 * Base URL for identity-verification ops routes.
 * - Empty: browser uses same-origin path `/api/identity-verification/...` (Vite proxies to IV service).
 * - Absolute: staging direct call, e.g. `http://iv-host:3001`.
 */
export function identityVerificationDashboardBaseUrl(): string {
    const raw = import.meta.env.VITE_IDENTITY_VERIFICATION_API_BASE as string | undefined;
    const base = typeof raw === 'string' ? raw.trim().replace(/\/$/, '') : '';
    return base;
}

export const identityVerificationDashboardHttp = axios.create({
    baseURL: identityVerificationDashboardBaseUrl(),
    headers: { 'Content-Type': 'application/json' },
});

identityVerificationDashboardHttp.interceptors.request.use((config) => {
    if (isOidcAdminAuth()) return attachOidcBearer(config);
    const t = getAdminConsoleToken();
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});

identityVerificationDashboardHttp.interceptors.response.use(
    (r) => r,
    (err: unknown) =>
        isOidcAdminAuth()
          ? handleOidcAxiosError(identityVerificationDashboardHttp, err)
          : handleAdminDashboardHttp401(err),
);
